/* @flow */
import Link from 'components/Link.jsx';
import Organization from 'entities/Organization';
import React from 'react';

class OrganizationLink extends React.Component {
  static propTypes = {
    organization: React.PropTypes.instanceOf(Organization),
  };

  static defaultProps = {
    placement: 'right',
    alignment: 'middle',
  };

  render() {
    const { organization, children, ...other } = this.props;

    return (
      <Link
        to={`/organizations/${this.props.organization.id}`}
        activeClassName="active"
        {...other}>
        {children || organization.getName()}
      </Link>
    );
  }
}

export default OrganizationLink;



// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationLink.jsx